import { Themed } from "@components/atoms/Themed"
import { defineBlock, EditableText, InnerBlocks, useInlineEditableValue } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Membership Grid Group",
}

export default defineBlock("memberships/membership-grid-group", (props) => {
  const headerText = useInlineEditableValue("membershipGridGroupHeader", "Example title text")

  return (
    <div className="flex justify-center shrink-0 flex-col w-fit gap-4 mb-4">
      <Themed theme={props.theme || "yellow"} className="w-full px-4 py-5 type-label-l">
        <EditableText as="div" store={headerText} placeholder="Example title text" plainText />
      </Themed>

      <div className="flex flex-nowrap flex-col shrink-0">
        <InnerBlocks
          allowedBlocks={["memberships/membership-grid-group-row"]}
          orientation="vertical"
          defaultBlocks={[
            ["memberships/membership-grid-group-row", {}],
            ["memberships/membership-grid-group-row", {}],
            ["memberships/membership-grid-group-row", {}],
            ["memberships/membership-grid-group-row", {}],
            ["memberships/membership-grid-group-row", {}],
          ]}
        />
      </div>
    </div>
  )
})
